import React, { useEffect, useState, useCallback } from "react";
import { Container, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import AllOrders from "./AllOrders";
import { toast } from "react-toastify";
import { APIClient } from "../../../helpers/api_helper";

const apiClient = new APIClient();

const OrderLojistas = ({ isLojista }) => {
  const [loading, setLoading] = useState(false);
  const [orderList, setOrderList] = useState([]);
  const [shouldFetch, setShouldFetch] = useState(true);

  const user = JSON.parse(localStorage.getItem("authUser"));

  const fetchBtcTransactions = useCallback(
    async (user_id) => {
      setLoading(true);
      const response = await apiClient.get(`/operacoes/${user_id}`);
      setLoading(false);

      if (response.sucesso) {
        return response.dados;
      } else {
        toast.error(response.mensagem);
        return [];
      }
    },
    []
  );

  useEffect(() => {
    if (shouldFetch) {
      const fetchData = async () => {
        const retorno = await fetchBtcTransactions(
          isLojista ? user.data._id : 0
        );
        setOrderList(retorno);
        setShouldFetch(false);
      };

      fetchData();
    }
  }, [shouldFetch, isLojista, user.data._id, fetchBtcTransactions]);

  document.title = "Ordens | Painel Fort Exchange";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Ordens"
            pageTitle={isLojista ? "Lojista" : "Aplicações"}
          />
          <Row>
            <AllOrders
              user={user}
              orderList={orderList}
              loading={loading}
              setShouldFetch={setShouldFetch}
            />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default OrderLojistas;
